import { FormInput, validateEmail } from 'components/shared/Forms/ReduxForm'
import Navigation from 'components/shared/Navigation/Navigation'
import logo from 'images/logo.svg'
import { I18n } from 'lib/i18n'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Field, getFormValues, reduxForm } from 'redux-form'
import { submitRequestPassword } from 'redux/user'
import {
  Button,
  Card,
  Container,
  Form,
  Grid,
  Icon,
  Image,
  List,
  Message,
  Segment,
} from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  const { email, passwordResetSuccess } = state.user
  const formValues = getFormValues(ownProps.form)(state)
  return { email, passwordResetSuccess, formValues }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      submitRequestPassword,
    },
    dispatch
  )
}

class ForgotPassword extends React.Component {
  // hint: as a security feature we don't show errors here
  render() {
    const {
      submitRequestPassword,
      passwordResetSuccess,
      formValues,
      invalid,
    } = this.props
    return (
      <div>
        <Segment basic className="loginArea">
          <Container>
            <Grid centered columns={1} stackable>
              <Grid.Row>
                <Grid.Column
                  width={12}
                  className="flex-center"
                  style={{ minHeight: '100px' }}>
                  <Image src={logo} size="small" />
                </Grid.Column>
              </Grid.Row>{' '}
              <Grid.Row>
                <Grid.Column width={6}>
                  <Card fluid className="rounded">
                    <Card.Content>
                      <Card.Header
                        as="h1"
                        content={I18n.t('login.forgot_password.title')}
                      />
                      <Card.Meta
                        content={I18n.t('login.forgot_password.header')}
                      />
                    </Card.Content>
                    <Card.Content extra>
                      <Card.Description>
                        <Form error={invalid}>
                          <Field
                            component={FormInput}
                            validate={validateEmail}
                            autoFocus
                            name="email"
                            size="large"
                            placeholder={I18n.t('global.email')}
                          />
                          <Message
                            info
                            hidden={!passwordResetSuccess}
                            size={'small'}
                            header={I18n.t(
                              'login.password.reset_success.header'
                            )}
                            content={I18n.t(
                              'login.password.reset_success.content'
                            )}
                          />
                          <Button
                            fluid
                            primary
                            disabled={invalid}
                            content={I18n.t('login.forgot_password.reset')}
                            onClick={(event) => {
                              event.preventDefault()
                              submitRequestPassword(formValues.email)
                            }}
                          />
                        </Form>
                      </Card.Description>
                    </Card.Content>
                    <Card.Content extra>
                      <List>
                        <List.Item>
                          <Icon name="angle right" />
                          <List.Content>
                            <Navigation
                              render="link"
                              as="link-item"
                              node="user/login"
                              children={I18n.t('global.cancel')}
                            />
                          </List.Content>
                        </List.Item>
                      </List>
                    </Card.Content>
                  </Card>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Container>
        </Segment>
      </div>
    )
  }
}

ForgotPassword = connect(mapStateToProps, mapDispatchToProps)(ForgotPassword)
ForgotPassword = reduxForm({ form: 'login' })(ForgotPassword)
export default ForgotPassword



// WEBPACK FOOTER //
// ./src/components/shared/Login/ForgotPassword.jsx